import { render, staticRenderFns } from "./SocialMediaLabel.vue?vue&type=template&id=54c7bbfe&scoped=true&"
import script from "./SocialMediaLabel.vue?vue&type=script&lang=js&"
export * from "./SocialMediaLabel.vue?vue&type=script&lang=js&"
import style0 from "./SocialMediaLabel.vue?vue&type=style&index=0&id=54c7bbfe&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54c7bbfe",
  null
  
)

export default component.exports